<div class="modal fade" id="dialogViewPessoa" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
  aria-labelledby="Pessoa" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="width: 400px;">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white" style="height: 60px">
        <h5 class="modal-title mt-0 pt-0" id="title" style="font-size: 1.2rem;">Cidadão</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body mb-1 pb-1">
        <div class="row">
          <div class="form-group col-12">
            <span class="font-weight-bold">{{entity.nome}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-between align-items-center mt-2">
            <span style="font-weight: bold;">Tipo Pessoa:</span>
            <ng-container *ngFor="let tipo of listaTipos">
              <span *ngIf="tipo.id === entity.especie">{{tipo.nome}}</span>
            </ng-container>
          </div>
          <div class="col-sm-12 d-flex justify-content-between align-items-center mt-2">
            <span style="font-weight: bold;">CPF/CNPJ:</span>
            <span *ngIf="entity.especie === '1' || entity.especie === '2'">{{entity.cpf_cnpj | CPF}}</span>
            <span *ngIf="entity.especie !== '1' && entity.especie !== '2'">{{entity.cpf_cnpj}}</span>
          </div>
          <div class="col-sm-12 d-flex justify-content-between align-items-center mt-2">
            <span style="font-weight: bold;">E-MAIL:</span>
            <span>{{entity.email}}</span>
          </div>
          <div class="col-sm-12 d-flex justify-content-between align-items-center mt-2">
            <span style="font-weight: bold;">Telefone:</span>
            <span>{{entity.telefone | TELEFONE}}</span>
          </div>
          <div class="col-sm-12 d-flex justify-content-between align-items-center mt-2">
            <span style="font-weight: bold;">Celular:</span>
            <span>{{entity.celular | TELEFONE}}</span>
          </div>
        </div>
        <hr style="margin: 5px 0;"/>
        <div class="row">
          <div class="col-sm-12">
            <span style="font-weight: bold;">Endereço: </span>
          </div>
          <div class="col-sm-12">
            <span style="font-size: 15px;">{{entity.endereco}} - {{entity.numero}}, {{entity.bairro}},
              {{entity.municipio}}</span>
          </div>
          <div class="col-sm-12 mt-2">
            <span style="font-weight: bold;">Complemento: </span>
          </div>
          <div class="col-sm-12">
            <span>{{entity.complemento}}</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="limparDados()" type="button" class="btn btn-link">Cancelar</button>
      </div>
    </div>
  </div>
</div>